import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchDayTasksParams {
	readonly date: string;
}

@Injectable({ providedIn: 'root' })
export class FetchDayTasksApiQuery extends ApiQuery<
	TaskOutput[],
	FetchDayTasksParams
> {
	client = 'iam';
	document = gql`
		query FetchDayTasks($date: LocalDate!) {
			fetchDayTasks(date: $date) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchDayTasks';
}
